import { AbstractControl, ValidationErrors } from '@angular/forms';
import { EUserDivision, IUser } from '../../user/user.model';
const OPTIONAL_DURATION_PATTERN: RegExp = /^((\d+):(\d{2}))?$/;
const wmgDivisions = [
  EUserDivision.WMG,
  EUserDivision.WMG_WCM,
  EUserDivision.WMG_MLR,
  EUserDivision.WMG_WCM_MLR,
  EUserDivision.CLA,
  EUserDivision.WMG_CLA,
  EUserDivision.ALL,
  EUserDivision.WMG_WCM_CLA,
];
export const parseDuration = (durationString: string): number | null => {
  const duration = durationString?.trim();
  if (duration && OPTIONAL_DURATION_PATTERN.test(duration)) {
    const [, , mm, ss] = duration.match(OPTIONAL_DURATION_PATTERN);
    const minutes: number = parseInt(mm, 10);
    const seconds: number = parseInt(ss, 10);

    return (minutes * 60 + seconds) * 1000;
  }

  return null;
};

export function durationValidator(control: AbstractControl): ValidationErrors | null {
  const duration = control.value?.trim();
  if (duration) {
    const [mm, ss] = duration.split(':').map(Number);
    if (mm > 0 || (mm === 0 && ss > 0)) {
      return null;
    }
  }
  return { invalidDuration: 'Duration must be greater than 00:00' };
}

export function formatUser(user: IUser, hasCountry?: boolean): string | null {
  return user ? formatPerson(user.firstName, user.lastName, user.companyCountry, hasCountry) || user.email : null;
}

export function formatPerson(firstName: string, lastName: string, country?: string, hasCountry?: boolean): string {
  return `${firstName ?? ''} ${lastName ?? ''} ${hasCountry && country !== null ? `(${country})` : ''}`.trim();
}

export function isWMGDivision(division: EUserDivision | any): boolean {
  return wmgDivisions.includes(division);
}

export function isMsrWmgColorPalette(syncType: string | any, division: EUserDivision): boolean {
  const msrSyncTypes = ['MSR', 'GMSR'];

  return wmgDivisions.includes(division) && msrSyncTypes.includes(syncType);
}

export function decodeHtmlEntities(input: string | any): string | any {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = input;
  return textarea.value;
}
